export const NAVIGATION_REQUEST_PROGRESS_EVENT =
  "sparelynk:navigation-request-progress";

export type NavigationRequestProgressPhase =
  | "start"
  | "headers"
  | "download"
  | "complete"
  | "error";

export type NavigationRequestProgressDetail = {
  requestId: string;
  phase: NavigationRequestProgressPhase;
  method: string;
  path: string;
  loaded?: number;
  total?: number | null;
  percent?: number | null;
  status?: number;
  cacheStatus?: string;
};

let navigationRequestSequence = 0;

export function createNavigationRequestId(): string {
  navigationRequestSequence += 1;
  return `request-${Date.now()}-${navigationRequestSequence}`;
}

export function emitNavigationRequestProgress(
  detail: NavigationRequestProgressDetail,
): void {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<NavigationRequestProgressDetail>(
      NAVIGATION_REQUEST_PROGRESS_EVENT,
      { detail },
    ),
  );
}
